import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs", { params: { limit: 500 } }).then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-screen-2xl mx-auto px-6 py-10">
      <div className="label-eyebrow">Audit</div>
      <h1 className="text-2xl font-bold tracking-tight mt-1">Audit log</h1>
      <p className="text-sm text-[#5E636E] mt-2">Append-only record of every product, COA, article, supplier, and order action.</p>
      <div className="mt-6 border border-[#D1D5DB] overflow-x-auto">
        <table className="w-full data-table">
          <thead>
            <tr>
              <th className="text-left px-4 py-2">Timestamp</th>
              <th className="text-left px-4 py-2">Actor</th>
              <th className="text-left px-4 py-2">Action</th>
              <th className="text-left px-4 py-2">Target</th>
              <th className="text-left px-4 py-2">Meta</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} data-testid={`audit-row-${a.id}`}>
                <td className="px-4 py-3 font-mono text-[11px]">{a.created_at?.slice(0, 19).replace("T", " ")}</td>
                <td className="px-4 py-3 font-mono text-xs">{a.actor_email}</td>
                <td className="px-4 py-3 font-mono text-xs"><span className="bg-[#F7F7F8] border border-[#D1D5DB] px-1.5 py-0.5">{a.action}</span></td>
                <td className="px-4 py-3 font-mono text-xs">{a.target_type} · {a.target_id?.slice(0, 12)}</td>
                <td className="px-4 py-3 font-mono text-[11px] text-[#5E636E] truncate max-w-xs">{JSON.stringify(a.meta || a.after || {})?.slice(0, 90)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
